import React from 'react';
import { Carousel } from "react-bootstrap";


const Hero_Section_Gallery = (props) => {
    return (
        <Carousel>
            {props.valHero.map((data, index) => (

                <Carousel.Item key={index} style={{ height: '35em' }}>
                    <img
                        className="d-block w-100"
                        src={data.hero_img.data[0].attributes.formats.large.url}
                        alt="blc gallery"
                    />
                    <Carousel.Caption>
                        <div className="gallery-center">
                            <h4 className="mytagmain"> {data.img_tagText} </h4>
                            <h5 className="py-2 text-center">{data.location_name}</h5>
                        </div>
                    </Carousel.Caption>
                </Carousel.Item>

            ))}
        </Carousel>
    );
};

export default Hero_Section_Gallery